<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card
        [advanceButton]="true"
        (outputButtonAdvance)="callFunction($event)"
        [advancedButtons]="specialButtons"
        [cardOptionBtnValue]="'menu.credit-invoice.view'|translate"
        [title]="'global.overview'|translate">
        <app-grid [grid]="grid" (sendParameters)="setParams($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<ng-template #amountPriceTemp let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.isCredit">- </span>{{row.amount | BackofficeCurrency}}
</ng-template>
<ng-template #amountExPriceTemp let-row="row" let-value="value" let-column="column">
  <span *ngIf="row.isCredit">- </span>{{row.amountEx | BackofficeCurrency}}
</ng-template>
<a #downloadLink href="" download style="display: none"></a>
<ng-template #statusTemplate let-row="row" let-value="value" let-column="column">
  {{ ('doctrine.backoffice.invoice.statuses.' + (value === 'credit_invoice' || value === 'overdue' ? 'open' : value )) | translate}}
  {{ (value == 'partial_paid' ? ' (' + (row.partialPaid | BackofficeCurrency) + ')' : '') }}
</ng-template>
<ng-template #typeTemplate let-row="row" let-value="value" let-column="column">
  {{ ('doctrine.invoice.types.' + (row.isCredit ? 'credit' : 'invoice')) | translate}}
</ng-template>
<ng-template #dueDateTemplate let-row="row" let-value="value">
  <div class="due-date-container">
    <span class="date">
      {{ !value ? '-' : formatDateString(value) }}
    </span>
    <ng-container *ngIf="row.status === 'overdue'">
      <span class="status-text">
        {{ 'doctrine.backoffice.invoice.statuses.overdue' | translate }}
        ({{ calculateOverdueDays(row.dueDate) }} days)
      </span>
    </ng-container>
  </div>
</ng-template>

<app-modal-basic #partialPaidModal>
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{'admin.backoffice.invoice.partial_paid'| translate }}
    </h4>
    <button type="button" class="close basic-close" (click)="partialPaidModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #partialPaidForm="ngForm">
      <div class="form-row row">
        <div class="form-group col-md-12">
          <input type="checkbox" class="border-checkbox" name="'hasCustomRow" [(ngModel)]="isPartialPaid">
          <label class="border-checkbox-label mb-0"
                 [for]="'isPartialPaid'">{{"admin.backoffice.invoice.overview.partial_paid"|translate: {invoiceId: invoiceId} }}</label>
        </div>
      </div>
      <div *ngIf="isPartialPaid">
        <div class="form-row row">
          <div class="form-group col-md-12">
            <label for="partialPaid">{{"doctrine.backoffice.invoice.amount" | translate}}<span
              class="star">*</span></label>
            <input required name="partialPaid"
                   id="partialPaid"
                   class="form-control"
                   pattern="\d+([.]\d+)?"
                   #invoicePartialPaid="ngModel"
                   [(ngModel)]="partialPaid">

            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="invoicePartialPaid.invalid && invoicePartialPaid.dirty && invoicePartialPaid.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="invoicePartialPaid.invalid && invoicePartialPaid.dirty && invoicePartialPaid.errors?.pattern">
              {{'errors.invalid'|translate}}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="partialPaidModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="editPartialPaid()"
            [disabled]="!partialPaidForm.valid || (!this.isEditPartialPaid && !this.isPartialPaid)">
      {{'global.actions.save' | translate}}
    </button>
  </div>
</app-modal-basic>


<app-modal-basic #creditInvoiceModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{'admin.backoffice.invoice.credit-invoice.modal-title'| translate }}
    </h4>
    <button type="button" class="close basic-close" (click)="creditInvoiceModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p [innerHTML]="'admin.backoffice.invoice.credit-invoice.are-you-sure'|translate:{invoicenumber: invoiceId}"></p>
    <p>{{'admin.backoffice.invoice.credit-invoice.choose-layout' | translate}}</p>
    <form novalidate #addCreditInvoiceForm="ngForm">
      <div class="form-group row">
        <div class="form-group form-default form-static-label col-6">
          <ng-select required name="type" id="type" [items]="templates" bindLabel="label" bindValue="value"
                     [(ngModel)]="selectedTemplate" [clearable]="false" [searchable]="false"></ng-select>
        </div>
      </div>

      <p>{{'admin.backoffice.invoice.credit-invoice-row'|translate }}</p>
      <p>
        {{'admin.backoffice.invoice.credit-invoice.remaining-amount'|translate}}: {{remainingAmount | BackofficeCurrency}}
      </p>
      <p *ngIf="currentCreditAmount > remainingAmount" class="text-danger">
        {{'admin.backoffice.invoice.credit-invoice.amount-exceed'|translate}}
      </p>
      <hr class="mb-4">

      <ng-container *ngFor="let creditInvoiceItem of creditInvoiceItems; let i = index">
        <div class="form-row row">
          <div class="form-group col-md-6">
            <label [for]="'description' + i">{{"doctrine.backoffice.credit-invoice.description" | translate}}<span
              class="star">*</span></label>
            <input required [name]="'description' + i"
                   [id]="'description' + i"
                   class="form-control"
                   #description="ngModel"
                   [(ngModel)]="creditInvoiceItem.description">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="description.invalid && description.dirty && description.errors?.required">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="form-group col-md-2">
            <label [for]="'amount' + i">{{"doctrine.backoffice.credit-invoice.amount" | translate}}   <span
              class="star">*</span></label>
            <input required [name]="'amount' + i"
                   type="number"
                   step="1"
                   min="1"
                   [id]="'amount' + i"
                   class="form-control"
                   #amount="ngModel"
                   [(ngModel)]="creditInvoiceItem.amount">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="amount.invalid && amount.dirty && amount.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="amount.errors?.min">
              {{'errors.positive_rang'|translate }}
            </div>
          </div>
          <div class="form-group col-md-3">
            <label [for]="'price' + i">{{"doctrine.backoffice.credit-invoice.price" | translate}} <span
              class="star">*</span></label>
            <input required [name]="'price' + i"
                   type="number"
                   step="0.01"
                   min="1"
                   [id]="'price' + i"
                   class="form-control"
                   #price="ngModel"
                   [(ngModel)]="creditInvoiceItem.price">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="price.invalid && price.dirty && price.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="price.errors?.min">
              {{'errors.positive_rang'|translate }}
            </div>
          </div>
          <div class="form-group col-md-2 mt-4" *ngIf="i !== 0">
            <a class="btn btn-lg btn-icon ripple light ms-1" (click)="removeCreditItem(i)">
              <i class="fa fa-trash trash-danger"></i>
            </a>
          </div>
        </div>
      </ng-container>
      <button class="btn btn-primary ripple light mb-0 mt-0" (click)="addCreditItem()">
        <i class="fa fa-plus"></i>
        &nbsp;{{'global.add' | translate}}
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="hideModal()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="onCredit()"
            [disabled]="!addCreditInvoiceForm.valid || disableCreditInvoiceBtn || (currentCreditAmount > remainingAmount) || currentCreditAmount <= 0">
      {{(isEdit ? 'global.actions.save' : 'admin.backoffice.invoice.credit-invoice.modal-credit') | translate}}
    </button>
  </div>
</app-modal-basic>

<app-generate-invoice #createCustomInvoiceModal="generateInvoice" (resultInvoice)="onInvoiceGenerated ($event)"></app-generate-invoice>
